<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-text="图片上传中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
			<p></p>
		</el-tooltip>
		<p class="error-msg" v-show="uploadError">上传失败,请重新上传!</p>
		<div v-if="previewSrc === ''" class="banner-add el-icon-plus" @click="uploadHandler"></div>
		<div v-else class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<w-image :src="previewSrc" alt="" class="img-preview" @click="uploadHandler" v-if="extension.indexOf('jpg') !== -1 || extension.indexOf('jpeg') !== -1 || extension.indexOf('png') !== -1"></w-image>
			<img class="img-preview" src="~/images/icon/icon-word.png" alt="" v-if="extension.indexOf('doc') !== -1">
			<img class="img-preview" src="~/images/icon/icon-excel.png" alt="" v-if="extension.indexOf('xls') !== -1">
			<img class="img-preview" src="~/images/icon/icon-ppt.png" alt="" v-if="extension.indexOf('ppt') !== -1">
			<img class="img-preview" src="~/images/icon/icon-pdf.png" alt="" v-if="extension.indexOf('pdf') !== -1">
			<img class="img-preview" src="~/images/icon/icon-rar.png" alt="" v-if="extension.indexOf('rar') !== -1">
			<img class="img-preview" src="~/images/icon/icon-zip.png" alt="" v-if="extension.indexOf('zip') !== -1">
			<div class="img-btn" v-show="activeFlag">
				<el-button type="primary" size="mini" class="img-el-button" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
				<el-button type="danger" size="mini" class="img-el-button" @click="deleteClick"><i class="el-icon-delete"></i></el-button>
				<el-button type="danger" class="img-el-button search-btn" @click="previewClick" size="mini" v-if="extension.indexOf('jpg') !== -1 || extension.indexOf('jpeg') !== -1 || extension.indexOf('png') !== -1"><i class="el-icon-search"></i></el-button>
			</div>
		</div>
		<input type="file" ref="file" id="file" v-show="false" @change="getFile">
	</div>
</template>

<script>
export default {
	name: 'SellerImgUplaod',
	props: {
		imgSrc: {
			type: String,
			default: ''
		},
		uploadError: Boolean,
		imgId: {
			type: String,
			default: ''
		},
		location: Number,
		extension: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			previewSrc: '',
			uploadType: new RegExp(/image\/png|image\/jpg|image\/jpeg/),
			uploadTypeText: 'png,jpg,jpeg',
			uploadTypeArr: ['png', 'jpg', 'jpeg', 'rar', 'zip', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'],
			uploadSize: 5,
			activeFlag: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null,
			fileFiles: ''
		}
	},
	created () {
		this.previewSrc = this.imgSrc
		// console.log(this.from)
	},
	watch: {
		imgSrc (val) {
			this.previewSrc = val
			this.$refs.file.value = ''
			this.$emit('update:uploadError', false)
		}
	},
	methods: {
		imgMouseOver () {
			this.activeFlag = true
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			this.$refs.file.click()
		},
		getFile (e) {
			this.$emit('update:uploadError', false)
			this.fileFiles = this.$refs.file.files[0]
			let files = e.target.files[0]
			// let type = files.type
			let name = files.name.split('.')[files.name.split('.').length - 1]
			let size = files.size / 1024 / 1024
			// if (!this.uploadType.test(type)) {
			// 	this.$message.error(`上传图片只支持${this.uploadTypeText}格式!`)
			// 	return false
			// }
			if (!this.uploadTypeArr.includes(name)) {
				this.$message.error(`请上传正确的文件格式!`)
				return false
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传文件大小不能超过${this.uploadSize}M!`)
				// this.$refs.file.value = ''
				// this.previewSrc = ''
				// this.$emit('update:imgSrc', '')
				// this.$emit('update:hasFile', '0')
				// this.$emit('update:uploadError', false)
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let reader = new FileReader()
			reader.readAsDataURL(files)
			reader.onloadend = () => {
				// let image = new Image()
				// image.src = reader.result
				// image.onload = () => {
				// if (image.width !== 750 && image.height !== 266) {
				// 	this.$message.error('请上传符合规定的广告图！')
				// 	this.$refs.file.value = ''
				// 	this.previewSrc = ''
				// 	return false
				// }
				// this.previewSrc = reader.result
				this.uploadImgHandler()
				// }
			}
		},
		deleteClick () {
			this.$emit('deletImg', this.imgId, this.location, this.imgSrc)
			// this.$confirm('一经删除无法恢复，是否继续？', '提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning',
			// 	closeOnClickModal: false
			// }).then(() => {
			// }).catch(() => {
			// })
		},
		uploadImgHandler () {
			this.$emit('uploadNewImg', this.imgSrc, this.location, this.imgId)
		},
		previewClick () {
			this.$emit('preview2', this.imgSrc)
		}
	}
}
</script>
<style lang="stylus" scoped>
/deep/.el-loading-mask {
	height: 100px
	margin-top: 20px
	border-radius: 6px;
}
// .license-class {
// 	width: 375px!important
// 	height: 200px!important
// 	.banner-add,.img-preview-block {
// 		width: 375px!important
// 		height: 180px!important
// 		line-height: 180px!important
// 	}
// 	/deep/.el-loading-mask {
// 		height: 180px
// 		margin-top: 20px
// 		border-radius: 6px;
// 	}
// }
.banner-upload {
	width: 100px;
	height: 100px;
	border-radius: 6px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	margin-bottom:10px
	margin-right: 20px
	float left
	.error-msg {
		color:red
		position:absolute
		top:0
		left:0
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box
		width: 100px;
		height: 100px;
		line-height: 100px;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.img-el-button {
		padding: 6px 10px
	}
	.img-preview-block {
		position:relative
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		.img-preview {
			width:100%
			height:100%
		}
		.img-btn {
			display: flex
			align-items: center
			justify-content: center
			position: absolute
			top:-10px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
			padding-bottom: 15px;
			.search-btn {
				position: absolute;
				left: 20px;
				bottom: 20px;
			}
		}
	}
}
</style>
